// extracted by mini-css-extract-plugin
export var chatHtmlText = "_oi-2";
export var chatLink = "_oi-0";
export var chatText = "_oi-1";